export const USER_TYPES = {
  SYSTEM: "system",
  TENANT: "tenant",
};

export const DEFAULT_PAGE_SIZE = 20;

export const USER_TYPE_LABELS = {
  [USER_TYPES.SYSTEM]: "System Users",
  [USER_TYPES.TENANT]: "Tenant Users",
};

export const USER_TYPE_SUBTITLES = {
  [USER_TYPES.SYSTEM]:
    "Manage platform system users, review account details, and update credentials.",
  [USER_TYPES.TENANT]:
    "Manage tenant-scoped users with paginated listing, details, and password updates.",
};
